import { END_ANNOTATION, START_ANNOTATION } from './actions'

// import get from 'lodash/get'

export const annotationInfo = (state = null, action) => {
  const annotationInfo = {}
  switch (action.type) {
    case START_ANNOTATION:
      return action.annotationInfo
    case END_ANNOTATION:
      annotationInfo.titleid = ''
      annotationInfo.colour = ''
      annotationInfo.type = ''
      annotationInfo.label = '' // get(state, 'label', '') // Don't clear the label
      return annotationInfo
    default:
      return state
  }
}
